import NavSlot from "@/components/navigation/tabs";
import {
  TIMESHEET_CALENDAR,
  TIMESHEET_WEEK,
  LIST,
  TIMESHEET_CARD,
} from "icons";
import { HEADER_CONTENT_PORTAL_ID } from "utils";
import { TimesheetHeader } from "../components/header";

export default function TimeSheetReviewLayout({ children }) {
  const navItems = [
    {
      id: 0,
      path: "/timesheet/reviews/day",
      label: "Review",
      icon: TIMESHEET_CARD,
    },
    {
      id: 1,
      path: "/timesheet/reviews/week",
      label: "Week",
      icon: TIMESHEET_WEEK,
    },
    {
      id: 2,
      path: "/timesheet/reviews/calendar",
      label: "Calendar",
      icon: TIMESHEET_CALENDAR,
    },
    {
      id: 3,
      path: "/timesheet/reviews/table",
      label: "Table",
      icon: LIST,
    },
  ];

  return (
    <div className="w-full">
      <TimesheetHeader>
        <div id={HEADER_CONTENT_PORTAL_ID} />
        <NavSlot navItems={navItems} defaultTab={1} />
      </TimesheetHeader>
      {children}
    </div>
  );
}
